import { render, staticRenderFns } from "./BaseArrowBoxIcon.vue?vue&type=template&id=103c117c&scoped=true"
import script from "./BaseArrowBoxIcon.vue?vue&type=script&lang=js"
export * from "./BaseArrowBoxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c117c",
  null
  
)

export default component.exports